/**
 * Default fixture for online booking settings.
 * Single source of truth for Figma-matching defaults.
 *
 * Used by:
 * - Server seed during org provisioning
 * - Client-side "Reset to Default" action
 */

// ─── Base Settings ───

export interface OnlineBookingSettingsDefaults {
  enabled: boolean;
  public_path: string | null;
  default_appointment_status_id: string | null;
}

export const ONLINE_BOOKING_DEFAULTS: OnlineBookingSettingsDefaults = {
  enabled: true,
  public_path: null,
  default_appointment_status_id: null,
};

// ─── Patient Field Settings ───

export interface BookingPatientFieldDefault {
  field_key: string;
  enabled: boolean;
  required: boolean;
  locked: boolean;
  section: string;
}

export const DEFAULT_BOOKING_PATIENT_FIELDS: BookingPatientFieldDefault[] = [
  // Required + locked fields
  {
    field_key: 'patient_name',
    enabled: true,
    required: true,
    locked: true,
    section: 'Personal Info',
  },
  {
    field_key: 'mobile_country_code',
    enabled: true,
    required: true,
    locked: true,
    section: 'Contact',
  },
  { field_key: 'mobile_number', enabled: true, required: true, locked: true, section: 'Contact' },

  // Optional fields (disabled by default)
  { field_key: 'email', enabled: false, required: false, locked: false, section: 'Contact' },
  {
    field_key: 'date_of_birth',
    enabled: false,
    required: false,
    locked: false,
    section: 'Personal Info',
  },
  { field_key: 'gender', enabled: false, required: false, locked: false, section: 'Personal Info' },
  {
    field_key: 'address_line_1',
    enabled: false,
    required: false,
    locked: false,
    section: 'Address',
  },
  {
    field_key: 'address_line_2',
    enabled: false,
    required: false,
    locked: false,
    section: 'Address',
  },
  { field_key: 'city', enabled: false, required: false, locked: false, section: 'Address' },
  { field_key: 'state', enabled: false, required: false, locked: false, section: 'Address' },
  { field_key: 'postal_code', enabled: false, required: false, locked: false, section: 'Address' },
  { field_key: 'country', enabled: false, required: false, locked: false, section: 'Address' },
  {
    field_key: 'emergency_contact_name',
    enabled: false,
    required: false,
    locked: false,
    section: 'Emergency',
  },
  {
    field_key: 'emergency_contact_phone',
    enabled: false,
    required: false,
    locked: false,
    section: 'Emergency',
  },
];
